import { AxiosError, AxiosResponse } from 'axios';
import { ETypeUser } from '../store/model/store.model';
import { getCustomerScopes } from '../../services/EscalationService';

export const getScopeRole = async () => {
    const handleResponseRole = async () => {
        return new Promise((resolve, reject) => {
            getCustomerScopes()
                .then((response: AxiosResponse) => {
                    const isTitular = (response.data as string[]).find((role: string) => role === 'titular');
                    const isPreclient =
                        new URLSearchParams(window.location.search).get('clientType') === ETypeUser.PRECLIENT;
                    const isLight = isPreclient ? ETypeUser.PRECLIENT : ETypeUser.LIGHT;
                    const isNormal = isPreclient ? ETypeUser.PRECLIENT : ETypeUser.NORMAL;
                    resolve(isTitular ? isNormal : isLight);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    };
    return handleResponseRole();
};

export const isLight = JSON.parse(window.localStorage.getItem('scope')!) === ETypeUser.LIGHT;
